<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of Columbia</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="90px"/>
<col width="300px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Welcome_to_Spooky_Columbia#Wel">Welcome to Spooky Columbia!</a></td></tr>
<tr><td>1 <a href="#/Chapter01#C1">Chapter 1.</a></td><td><a href="#/Chapter01#C1">The Katy Tunnel</a></td></tr>
<tr><td>2 <span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Battle of Goslin Lane</span></td></tr>
<tr><td>3 <span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Haunted Hill</span></td></tr>
<tr><td>4 <span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Farmhouse Haunting</span></td></tr>
<tr><td>5 <span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">John Boone’s Piano</span></td></tr>
<tr><td>6 <span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">The Pond</span></td></tr>
<tr><td>7 <span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">University Ghosts</span></td></tr>
<tr><td>8 <span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Lilac Hill</span></td></tr>
<tr><td>9 <span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">John Neihardt and the Ghosts of Skyrim</span></td></tr>
<tr><td>10 <span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Ravenswood Mansion</span></td></tr>
<tr><td colspan="2"><span href="#/A_Ghostly_Goodbye#Gho" title="Link target outside of Sample">A Ghostly Goodbye</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0b8dbb23